import React, { useState, useEffect } from "react";
import CloseIconButton from "../../../../components/CloseIconButton";
import AddButton from "../../../../components/AddButton";
import EditOutlineButton from "../../../../components/EditOutlineButton";
import VendorSystemInformationView from "./VendorSystemInformationView";
import { VendorOfficesTable } from "./VendorOfficesTable";
import {
  ChevronRightIcon,
  BuildingStorefrontIcon,
} from "@heroicons/react/24/solid";

import { Disclosure } from "@headlessui/react";
import GoogleMaps from "../../../../components/GoogleMaps";
import {
  addStateVendor,
  vendorServiceId,
  vendorViewData,
} from "../atoms/atoms";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { FIELDPERMISSIONS, PERMISSIONS } from "../../../PermissionsConstants";
import {
  DisableVendorField,
  officeVendorAddState,
  officeVendorEditState,
  OfficeVendorSvcViewData,
  rowForEditOfficeSettings,
} from "../../OfficeSettings/atoms/atoms";
import useGetVendorOffices from "../hooks/useGetVendorOffices";
import { VendorLeasedEquipmentTable } from "./VendorLeasedEquipmentTable";
import useGetVendorLeasedEquipment from "../hooks/useGetVendorLeasedEquipment";
import { useHistory } from "react-router-dom";
import { mainSelectedTab } from "../../atoms";
import { VendorTabs } from "../../../VendorTab/VendorTab";
// import VendorSecurityView from "./VendorSecurityView";

const VendorView = ({ onClickCancelShow, handleEdit }) => {
  //recoil calls
  const setRowToEdit = useSetRecoilState(rowForEditOfficeSettings);
  const [actionAddState, setActionAddState] = useRecoilState(addStateVendor);
  const [, setDisableVendorField] = useRecoilState(DisableVendorField);
  const [, setShowOfficeVendorForm] = useState(false);
  const data = useRecoilValue(vendorViewData);
  const [, setVendorOfficesList] = useState([]);
  const { data: vendorOffices, isSuccess: useBusLicenseSuccess } =
    useGetVendorOffices(data.id);

  useEffect(() => {
    if (useBusLicenseSuccess && vendorOffices) {
      if (vendorOffices?.length > 0) {
        setVendorOfficesList(
          vendorOffices?.map((data) => ({
            ...data,
          }))
        );
      }
    }
  }, [useBusLicenseSuccess, vendorOffices]);

  const { data: vendorLeased } = useGetVendorLeasedEquipment(data?.id);

  const addPermission = PERMISSIONS.permission_vendor_add;
  const editPermission = PERMISSIONS.permission_vendor_edit;

  const addVendorOffice = PERMISSIONS.permission_vendor_office_add;
  const viewVendorOffice = PERMISSIONS.permission_vendor_office_view;

  const viewUserPermission = FIELDPERMISSIONS.fieldpermission_vendor_user;
  const viewPassPermission = FIELDPERMISSIONS.fieldpermission_vendor_sensitive;

  const addLeasedPermission = PERMISSIONS.permission_leasedequipment_add;
  // const viewVendorSecurity = PERMISSIONS.permission_vendor_vendorSecurity_view;

  const userPermissions = useRecoilValue(permissionsSelector);
  const [, setOfficeVendorServiceEditState] = useRecoilState(
    officeVendorEditState
  );
  const [, setOfficeVendorServiceAddState] =
    useRecoilState(officeVendorAddState);
  const [, setRowViewData] = useRecoilState(OfficeVendorSvcViewData);
  const [, setVendorId] = useRecoilState(vendorServiceId);

  //Function for Add Button on Office
  const onClickOfficeVendorModal = () => {
    setRowViewData([]);
    setShowOfficeVendorForm(true);
    setOfficeVendorServiceAddState(true);
    setOfficeVendorServiceEditState(false);
    setDisableVendorField(true);
    setRowToEdit([]);
    setVendorId(data);
  };

  const history = useHistory();
  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);

  const handleLink = () => {
    const url = `/vendortab/vendor`;
    history.push({
      pathname: `/officesettings/leasedequipment`,
      state: {
        action: "fromVendorLE",
        vendorId: data.id,
      },
    });
    window.location.reload();
    let userTabs = [
      {
        to: "",
      },
    ];

    [...VendorTabs].forEach((tabs) => {
      let temp = [...userPermissions].filter(
        (user) => user === tabs.permission
      );
      if (temp.length > 0)
        userTabs.push({
          to: tabs.to,
        });
    });

    userTabs.shift();
    const index = userTabs.findIndex((c) => c.to === url);
    setSelectedIndex(index);
  };

  const [pass, setPass] = useState("");
  const astric_pass = [];

  for (let i = 0; i < pass?.length; i++) {
    if (i > pass.length - 5) {
      astric_pass.push(pass[i]);
    } else if (pass.length - 4) {
      astric_pass.push("*");
    } else {
      astric_pass.push(pass[i]);
    }
  }

  useEffect(() => {
    setPass(data?.vendorPassword);
  }, [data?.vendorPassword]);

  return (
    <div className="relative w-full py-2 box-shadow border-quinary border-l-2">
      <CloseIconButton onClick={() => onClickCancelShow()} />
      <div className="flex mx-4 justify-between pb-2 border-secondary border-b-2">
        <div className="flex gap-2 items-center">
          <div>
            <BuildingStorefrontIcon className="text-white bg-blue-500 rounded-md h-8 w-8 p-1" />
          </div>

          <div className="flex flex-col leading-tight">
            <div className="flex flex-col leading-tight">
              <div className="text-xs font-medium text-gray-500">
                Vendor and Service
              </div>
            </div>
            <div className="blueAndBold ">{data?.name}</div>
          </div>
        </div>

        <div className="flex items-center gap-2">
          {userPermissions.includes(addPermission) ? (
            <AddButton
              buttonText="Add"
              onClick={() => {
                setActionAddState(!actionAddState);
              }}
              disabled={false}
            />
          ) : (
            ""
          )}
          {userPermissions.includes(editPermission) ? (
            <EditOutlineButton
              onClick={() => handleEdit(data)}
              disabled={false}
            />
          ) : (
            ""
          )}
        </div>
      </div>
      <>
        <Disclosure defaultOpen>
          {({ open }) => (
            <div className="mx-4 mt-4 mb-2 bg-white box-shadow rounded-md">
              <Disclosure.Button className="disclosureBtn ml-2">
                <ChevronRightIcon
                  className={`${
                    open ? "transform rotate-90" : ""
                  } text-gray-500 w-5 h-5 `}
                />
                <div className="disclosureLabel ml-2">Vendor Details</div>
              </Disclosure.Button>

              <Disclosure.Panel className="text-xs bg-white">
                <div className="grid xl:grid-cols-2 lg1:grid-cols-2 text-xs px-10  py-2  gap-y-1 md:grid-cols-2 sm:grid-cols-1 ">
                  {/* left */}
                  <div className="gap-2 ">
                    <div className="grid grid-cols-2 py-1 border-b border-gray-200 ">
                      <label className="expandedLabel fontExpand">
                        Vendor Name
                      </label>

                      <div className="expandedData fontExpand">
                        {data?.name}
                      </div>
                    </div>
                    <div className="grid grid-cols-2 py-1 border-b border-gray-200 ">
                      <label className="expandedLabel fontExpand">
                        Vendor Code:
                      </label>

                      <div className="expandedData fontExpand">
                        {data?.vendorCode}
                      </div>
                    </div>

                    <div className="grid grid-cols-2 py-1 border-b border-gray-200">
                      <label className="expandedLabel fontExpand">Type:</label>
                      <div className="expandedData fontExpand">
                        {data?.vendorTypeName}
                      </div>
                    </div>

                    <div className="grid grid-cols-2 py-1 border-b border-gray-200">
                      <label className="expandedLabel fontExpand">Email:</label>
                      <div className="expandedData fontExpand">
                        {data?.email}
                      </div>
                    </div>

                    <div className="grid grid-cols-2 py-1 border-b border-gray-200">
                      <label className="expandedLabel fontExpand">
                        Website:
                      </label>
                      <div className="expandedData fontExpand">
                        {data?.website}
                      </div>
                    </div>

                    <div className="grid grid-cols-2 py-1 border-b border-gray-200">
                      <label className="expandedLabel fontExpand">
                        Account Number:
                      </label>
                      <div className="expandedData fontExpand">
                        {data?.accountNumber}
                      </div>
                    </div>
                  </div>

                  {/* right */}
                  <div className="gap-2 ">
                    <div className="grid grid-cols-2 py-1 border-b border-gray-200">
                      <label className="expandedLabel fontExpand">
                        Contact:
                      </label>
                      <div className="expandedData fontExpand">
                        {data?.contact}
                      </div>
                    </div>

                    <div className="grid grid-cols-2 py-1 border-b border-gray-200">
                      <label className="expandedLabel fontExpand">Phone:</label>
                      <div className="expandedData fontExpand">
                        {data?.phone}
                      </div>
                    </div>
                    {userPermissions.includes(viewUserPermission) && (
                      <div className="grid grid-cols-2 py-1 border-b border-gray-200">
                        <label className="expandedLabel fontExpand">
                          User:
                        </label>
                        <div className="expandedData fontExpand">
                          {data?.vendorUser}
                        </div>
                      </div>
                    )}
                    {userPermissions.includes(viewPassPermission) && (
                      <div className="grid grid-cols-2 py-1 border-b border-gray-200">
                        <label className="expandedLabel fontExpand">
                          Password:
                        </label>
                        <div className="expandedData fontExpand">
                          {data?.vendorPassword !== "" ? astric_pass : ""}
                        </div>
                      </div>
                    )}
                    <div className="grid grid-cols-2 py-1 border-b border-gray-200">
                      <label className="expandedLabel fontExpand">
                        Payment Terms:
                      </label>
                      <div className="expandedData fontExpand">
                        {data?.paymentTerms ? (
                          "Net " + data?.paymentTerms
                        ) : (
                          <div className="text-secondary italic text-xs3">
                            To be populated
                          </div>
                        )}
                      </div>
                    </div>
                    {data.vendorType === 8 && (
                      <>
                        <div className="grid grid-cols-2 py-1 border-b border-gray-200">
                          <label className="expandedLabel fontExpand">
                            Toner Request Email:
                          </label>
                          <div className="expandedData fontExpand">
                            {data?.tonerRequestEmail}
                          </div>
                        </div>
                        <div className="grid grid-cols-2 py-1 border-b border-gray-200">
                          <label className="expandedLabel fontExpand">
                            Toner Request Phone:
                          </label>
                          <div className="expandedData fontExpand">
                            {data?.tonerRequestPhone}
                          </div>
                        </div>
                      </>
                    )}
                    {data.vendorType === 9 && (
                      <>
                        <div className="grid grid-cols-2 py-1 border-b border-gray-200">
                          <label className="expandedLabel fontExpand">
                            Recurrency of the Service:
                          </label>
                          <div className="expandedData fontExpand">
                            {data?.vendorRecurrencyName}
                          </div>
                        </div>
                      </>
                    )}
                    <div className="grid grid-cols-2 py-1 border-b border-gray-200">
                      <label className="expandedLabel fontExpand">
                        Inactive Account:
                      </label>
                      <div className="expandedData fontExpand">
                        {data?.status}
                      </div>
                    </div>
                  </div>
                </div>
              </Disclosure.Panel>
            </div>
          )}
        </Disclosure>
        {/* {userPermissions.includes(viewVendorSecurity) && (
          <VendorSecurityView data={data} />
        )} */}
        <Disclosure defaultOpen>
          {({ open }) => (
            <div className="mx-4 mb-2 bg-white box-shadow rounded-md">
              <Disclosure.Button className="disclosureBtn ml-2">
                <ChevronRightIcon
                  className={`${
                    open ? "transform rotate-90" : ""
                  } w-5 h-5 text-gray-500`}
                />
                <div className="disclosureLabel ml-2">
                  {"Address Information"}
                </div>
              </Disclosure.Button>
              <Disclosure.Panel className="text-xs ">
                <div className="grid xl:grid-cols-2 lg1:grid-cols-2 text-xs px-10  py-2  gap-y-1 md:grid-cols-2 sm:grid-cols-1 ">
                  <div className="grid grid-cols-2 py-1 border-b border-gray-200">
                    <label className="expandedLabel fontExpand">Address:</label>
                    <div className="expandedData fontExpand">
                      <div>{data.street}</div>
                      <div>
                        {data?.city ? data.city + ", " : ""} {data.zipCode}
                      </div>
                      <div>{data.state}</div>
                      {data.locationLatitude && data.locationLongitude && (
                        <GoogleMaps
                          center={{
                            lat: parseFloat(data.locationLatitude),
                            lng: parseFloat(data.locationLongitude),
                          }}
                          physicalAddress={
                            data.street +
                            " " +
                            data.city +
                            ", " +
                            data.state +
                            " " +
                            data.zipCode
                          }
                        />
                      )}
                    </div>
                  </div>
                </div>
              </Disclosure.Panel>
            </div>
          )}
        </Disclosure>
        {userPermissions.includes(viewVendorOffice) && (
          <Disclosure defaultOpen>
            {({ open }) => (
              <div className="mx-4 mb-2 bg-white box-shadow rounded-md">
                <div className="space-y-2">
                  <div className="w-full space-y-2">
                    <div className="flex flex-row justify-between">
                      <Disclosure.Button className="disclosureBtn ml-2">
                        <ChevronRightIcon
                          className={`${
                            open ? "transform rotate-90" : ""
                          } w-5 h-5 text-gray-500`}
                        />
                        <div className="disclosureLabel ml-2">{"Offices"}</div>
                      </Disclosure.Button>
                      <div className="flex flex-row justify-between mt-2">
                        <div className="mr-4">
                          {userPermissions.includes(addVendorOffice) && (
                            <AddButton
                              buttonText="Add"
                              onClick={() => onClickOfficeVendorModal()}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Disclosure.Panel className="text-xs ">
                  {<VendorOfficesTable data={vendorOffices} />}
                </Disclosure.Panel>
              </div>
            )}
          </Disclosure>
        )}
        {vendorLeased?.length > 0 && (
          <Disclosure defaultOpen>
            {({ open }) => (
              <div className="mx-4 mb-2 bg-white box-shadow rounded-md">
                <div className="space-y-2">
                  <div className="w-full space-y-2">
                    <div className="flex flex-row justify-between">
                      <Disclosure.Button className="disclosureBtn ml-2">
                        <ChevronRightIcon
                          className={`${
                            open ? "transform rotate-90" : ""
                          } w-5 h-5 text-gray-500`}
                        />
                        <div className="disclosureLabel ml-2">
                          {"Leased Equipment"}
                        </div>
                      </Disclosure.Button>
                      <div className="flex flex-row justify-between mt-2">
                        <div className="mr-4">
                          {userPermissions.includes(addLeasedPermission) && (
                            <AddButton
                              buttonText="Add"
                              onClick={() => handleLink()}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Disclosure.Panel className="text-xs ">
                  {<VendorLeasedEquipmentTable data={vendorLeased} />}
                </Disclosure.Panel>
              </div>
            )}
          </Disclosure>
        )}
        <Disclosure defaultOpen>
          {({ open }) => (
            <div className="mx-4 mb-2 bg-white box-shadow rounded-md">
              <Disclosure.Button className="disclosureBtn ml-2">
                <ChevronRightIcon
                  className={`${
                    open ? "transform rotate-90" : ""
                  } w-5 h-5 text-gray-500`}
                />
                <div className="disclosureLabel ml-2">
                  {"System Information"}
                </div>
              </Disclosure.Button>
              <Disclosure.Panel className="text-xs ">
                {<VendorSystemInformationView data={data} />}
              </Disclosure.Panel>
            </div>
          )}
        </Disclosure>
      </>
    </div>
  );
};

export default VendorView;
